import BigPanel from "../../components/BigPanel/BigPanel";

function Haftungsausschluss() {
  return (
    <BigPanel title="Haftungsausschluss">
      <h2>Inhalt des Onlineangebotes</h2>
      <p>
        Haftungsansprüche gegen Fit-to-Clean, die sich auf materielle oder
        immaterielle Schäden beziehen, welche durch die Nutzung oder Nichtnutzung
        der angebotenen Informationen verursacht wurden, sind ausgeschlossen,
        sofern kein nachweislich vorsätzliches oder grob fahrlässiges
        Verschulden unsererseits vorliegt.
      </p>

      <h2>Verfügbarkeit der Website</h2>
      <p>
        Wir sind bemüht, den Dienst jederzeit verfügbar zu halten. Eine
        ununterbrochene oder fehlerfreie Bereitstellung können wir jedoch nicht
        garantieren. Eine Haftung für zeitweise Ausfälle wird ausgeschlossen.
      </p>

      <h2>Verweise und externe Links</h2>
      <p>
        Diese Website enthält Links zu externen Internetseiten, auf deren Inhalte
        wir keinen Einfluss haben. Für Inhalte verlinkter Seiten sind
        ausschließlich deren Betreiber verantwortlich. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Hinweise
        auf Rechtsverstöße nicht zumutbar. Bei Bekanntwerden von
        Rechtsverletzungen werden solche Links umgehend entfernt.
      </p>

      <h2>Änderungsvorbehalt</h2>
      <p>
        Wir behalten uns vor, Teile des Internetangebotes oder das gesamte
        Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen oder zu
        löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
      </p>

      <h2>Keine Abmahnung ohne vorherigen Kontakt</h2>
      <p>
        Sollten Inhalte oder Darstellungsteile dieser Website Rechte Dritter
        verletzen, bitten wir um eine entsprechende Nachricht ohne Kostennote.
        Wir garantieren, dass rechtlich beanstandete Passagen unverzüglich
        entfernt oder angepasst werden, ohne dass die Einschaltung eines Anwalts
        erforderlich ist.
      </p>
      <p>
        Kosten, die ohne vorherige Kontaktaufnahme entstehen, werden zurückgewiesen.
        Gegebenenfalls erfolgt Gegenklage wegen Verletzung der genannten
        Bestimmungen.
      </p>
    </BigPanel>
  );
}

export default Haftungsausschluss;
